// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1RShJ","footer":"Form_footer__1AI_t"};